import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Region, RegionSingleResponse, StoreRegionRequest, createRegionFormGroup } from '@lib/api/models/region';
import { DialogService, ComponentsModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ReactiveFormsModule } from '@angular/forms';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { RegionService } from '@lib/region/region.service';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';

@Component({
    selector: 'app-edit-regions-basic-details',
    imports: [
        ComponentsModule,
        ReactiveFormsModule,
        ErrorPanelComponent
    ],
    templateUrl: './edit-region-general-information-dialog.component.html',
    standalone: true,
    styleUrl: './edit-region-general-information-dialog.component.scss'
})
export class EditRegionGeneralInformationDialogComponent {

    private readonly _regionService = inject(RegionService);
    private readonly _snackBar = inject(SnackBarService);

    protected readonly region = inject<Region>(DIALOG_DATA);
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    protected readonly regionDetailsFormGroup = createRegionFormGroup(this.region);

    updateRegionRequest = new SendableRequest<RegionSingleResponse, StoreRegionRequest>({
        request: (payload) => this._regionService.updateRegion(this.region.id, payload!),

        onSend: () => {
            this.regionDetailsFormGroup.disable();
        },

        onSuccess: () => {
            this.regionDetailsFormGroup.enable();
            this._snackBar.open({
                colour: 'success',
                icon: 'check',
                title: 'Region Updated'
            });
            this.dialogRef.close();
        },

        onError: () => {
            this.regionDetailsFormGroup.enable();
        }
    });

    update() {
        if (this.updateRegionRequest.loading()) {
            return;
        }

        if (!this.regionDetailsFormGroup.valid) {
            const invalidFields = Object.keys(this.regionDetailsFormGroup!.controls).filter(key => {
                return this.regionDetailsFormGroup?.get(key)?.invalid;
            });

            const errorFields = invalidFields.join(', ');

            this._snackBar.open({
                colour: 'error',
                icon: 'error',
                title: 'Invalid fields: ' + errorFields
            });

            return;
        }


        const regionData: StoreRegionRequest = {
            name: this.regionDetailsFormGroup.get('name')?.value ?? '',
            reference: this.regionDetailsFormGroup.get('reference')?.value ?? '',
            status: this.regionDetailsFormGroup.get('status')?.value ?? true
        };

        this.updateRegionRequest.send(regionData);
    }

    public static show(dialog: DialogService, data: Region) {
        return dialog.openDialog<DialogRef, Region>(EditRegionGeneralInformationDialogComponent, {
            data
        });
    }
}
